module.exports = __webpack_public_path__ + "fonts/Roboto-LightItalic.6083b817.ttf";